import { LoginByAccountOptionParams } from "./type";
import { User } from "authing-js-sdk";
import Axios from "axios";
import { message as Message } from "antd";
import { ErrorCodes } from "@/constants/enum";

export const loginByAccount: (
  account: string,
  password: string,
  options?: LoginByAccountOptionParams
) => Promise<User> = async (account, password, options) => {
  const encrypt = window.__authing__.options.encryptFunction;
  const publicKey = window.__config__.publicKey;

  const { code, message, data } = await Axios.post("api/v2/login/account", {
    account,
    password: await encrypt!(password, publicKey),
    ...options,
  });

  if (code !== 200) {
    if (
      ![
        ErrorCodes.LOGIN_REQUIRED,
        ErrorCodes.ACCOUNT_LOCK,
        ErrorCodes.PASSWORD_EXPIRED,
        ErrorCodes.ACCOUNT_LOCKED,
      ].includes(code)
    ) {
      // 如果开启了个人mfa 或者企业版 mfa 提示框使用 warn 不要用报错 by donglyc
      if (code === 1635 || code === 1636) {
        Message.warn(message);
      } else {
        Message.error(message);
      }
    }
    // eslint-disable-next-line no-throw-literal
    throw {
      code,
      message,
      data,
    };
  }
  return data;
};
